var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-page"},[_c('zlm-mobile-dynamic-list',{attrs:{"config":_vm.config,"type":"line"},on:{"onLoad":_vm.onLoad,"onRefresh":_vm.onRefresh,"handleClick":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }